import { render, staticRenderFns } from "./customerType.vue?vue&type=template&id=7a56a2fd&"
import script from "./customerType.vue?vue&type=script&lang=js&"
export * from "./customerType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a56a2fd')) {
      api.createRecord('7a56a2fd', component.options)
    } else {
      api.reload('7a56a2fd', component.options)
    }
    module.hot.accept("./customerType.vue?vue&type=template&id=7a56a2fd&", function () {
      api.rerender('7a56a2fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/customerType.vue"
export default component.exports